import { useTranslation } from 'react-i18next';

const barColors = ['bg-[#4F2D63]', 'bg-[#7B4FA0]', 'bg-[#2D6348]', 'bg-[#6B4500]'];

export default function TimelineBar() {
  const { t } = useTranslation();

  const items = [1, 2, 3, 4].map((n, i) => ({
    label: t(`sllc_tl_${n}_label`),
    time: t(`sllc_tl_${n}_time`),
    color: barColors[i],
  }));

  return (
    <section className="py-12 bg-[#1a0d24]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <p className="text-center text-white/60 text-xs font-semibold uppercase tracking-widest mb-8">
          {t('sllc_timeline_title')}
        </p>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {items.map((item, idx) => (
            <div key={item.label} className="flex items-center gap-3">
              {/* Number */}
              <div className={`w-8 h-8 flex items-center justify-center rounded-full ${item.color} flex-shrink-0`}>
                <span className="text-white text-xs font-bold">{idx + 1}</span>
              </div>
              {/* Text */}
              <div>
                <div className="text-white text-sm font-semibold leading-tight">{item.label}</div>
                <div className="text-white/50 text-xs">{item.time}</div>
              </div>
              {/* Arrow connector (not on last) */}
              {idx < 3 && (
                <div className="hidden lg:block ml-auto">
                  <i className="ri-arrow-right-line text-white/20 text-base" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
